export default {
  data: function() {
    return {
      tableHeads: [
        {
          label: '姓名',
        },
        {
          label: '职能模块',
          type: 'multSelect',
        },
        {
          label: '公司',
        },
        {
          label: '部门',
        },
        {
          label: '目前职位',
        },
        {
          label: '曾任职公司',
        },
        {
          label: '手机',
        },
        {
          label: '其他',
        },
        {
          label: '座机',
        },
        {
          label: '邮箱',
        },
        {
          label: '旧系统沟通备注',
        },
        {
          label: '地域',
          type: 'multSelect',
        },
        {
          label: '性别',
        },
        {
          label: '长期意向',
        },
        {
          label: '规模',
        },
        {
          label: '管理基金数量',
        },
        {
          label: '管理基金',
        },
        {
          label: '任职期',
        },
        {
          label: '行业',
        },
        {
          label: '细分职能',
          type: 'multSelect',
        },
        {
          label: '平台',
        },
        {
          label: '职级',
        },
        {
          label: '业绩',
        },
        {
          label: '擅长方向',
          type: 'multSelect',
        },
        {
          label: '个性标签',
          type: 'multSelect',
        },
        {
          label: '学历标签',
          type: 'multSelect',
        },
        {
          label: '语言标签',
          type: 'multSelect',
        },
        {
          label: '职业资格',
          type: 'multSelect',
        },
        {
          label: '管理职级',
        },
        {
          label: '专业职级',
        },
        {
          label: '下属个数',
        },
        {
          label: '汇报上级',
        },
        {
          label: '期望行业',
          type: 'multSelect',
        },
        {
          label: '期望地域',
          type: 'multSelect',
        },
        {
          label: '期望固薪',
        },
        {
          label: '期望奖金',
        },
        {
          label: '简介',
        },
        {
          label: '婚育',
        },
        {
          label: '出生年月',
        },
        {
          label: '籍贯',
        },
        {
          label: '学历',
        },
        {
          label: '本科院校',
        },
        {
          label: '硕士院校',
        },
        {
          label: '到现公司时间',
        },
        {
          label: '从业起始年',
        },
        {
          label: '微信',
        },
      ],
    }
  },
}
